import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TraceClassDecorator } from '@sentry/angular';
import { ProviderStateService } from 'src/app/services/provider-state.service';


@TraceClassDecorator()
@Component({
    selector: 'app-share-patient-profile',
    templateUrl: './share-patient-profile.component.html',
    styleUrls: [
        './share-patient-profile.component.css',
        '../../../../../assets/css/custom-egd.css'
    ]
})
export class SharePatientProfileComponent implements OnInit {
    patient_guid: string = null;
    token: string = null;
    consultation_id: number = null;
    posting: boolean = null;
    slug: string = "";

    constructor(private route: ActivatedRoute, private router: Router,
        private readonly providerstateService: ProviderStateService
    ) {}

    ngOnInit(): void {
        this.slug = this.providerstateService.getProviderSlug();
        this.posting = true;
        this.route.params.subscribe(async (params) => {
            this.patient_guid = params.patient_guid;
            this.token = params.token;
            this.consultation_id = null;

            // if(this.patient_guid==null || this.consultation_id==null){
            //     await this.GetMessage();

            // }
            // else{
            //     this.response.success=false;
            //     this.response.error={
            //         code:"TOK",
            //         message:"Invalid tokens"
            //     }
            // }
        });
        if (this.token == null) {
            this.RouterNavigation( '/invalidlink');
        }

        this.posting = false;
    }

    RouterNavigation(path: string) {
        this.router.navigate([path]);
    }
}
